// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3gKFX","title":"ClientInsurance_title__10rfn","itemText":"ClientInsurance_itemText__185MU"};